import type {
  CurrencyFormat,
  WalletAuditRecord,
  WalletBalance,
  WalletLedgerPage,
  WithdrawPrecheck,
} from '@/entities/wallet/types';
import { clientEnv } from '@/shared/config/env';
import { requestJson } from '@/shared/request/http-client';
import { ensureSimulationBound } from '@/shared/simulation/simulation-session';

const siteParam = () => encodeURIComponent(clientEnv.siteId);

export const fetchWalletBalance = async (authToken: string, signal?: AbortSignal) => {
  await ensureSimulationBound();
  return requestJson<WalletBalance>(`/v1/app/wallet/balance?siteId=${siteParam()}`, {
    authToken,
    signal,
  });
};

export const fetchCurrencyFormat = async (authToken: string) => {
  await ensureSimulationBound();
  return requestJson<CurrencyFormat>(`/v1/app/wallet/currency?siteId=${siteParam()}`, {
    authToken,
  });
};

export const fetchWalletLedger = (
  authToken: string,
  pageSize = 20,
  options?: { businessType?: string; pageNo?: number; range?: string; signal?: AbortSignal },
) => {
  const search = new URLSearchParams({
    siteId: clientEnv.siteId,
    pageSize: String(pageSize),
  });
  if (options?.pageNo) search.set('pageNo', String(options.pageNo));
  if (options?.range) search.set('range', options.range);
  if (options?.businessType) search.set('businessType', options.businessType);
  return requestJson<WalletLedgerPage>(`/v1/app/wallet/ledger?${search.toString()}`, {
    authToken,
    signal: options?.signal,
  });
};

export const fetchAuditRecords = (authToken: string) =>
  requestJson<WalletAuditRecord[]>(
    `/v1/app/wallet/audit-records?siteId=${siteParam()}`,
    { authToken },
  );

export const fetchWithdrawPrecheck = (authToken: string) =>
  requestJson<WithdrawPrecheck>(
    `/v1/app/wallet/withdraw-precheck?siteId=${siteParam()}`,
    { authToken },
  );
